export default __webpack_public_path__ + "static/media/solar_symbol.d0b89bc0.png";